/**
 * Nexus-Jobs Fixture.
 * Spec: lmm-wiki/wiki/orbit-specs/nexus-jobs-monitor.md
 */

const NOW = Date.now();
const JOBS = [
  {
    id: 'job_42a',
    type: 'domain.provision',
    status: 'completed',
    subscription_id: 17,
    current_step: 4, total_steps: 4,
    created_at: new Date(NOW - 6 * 3600_000).toISOString(),
    finished_at: new Date(NOW - 5.9 * 3600_000).toISOString(),
    payload: { domain: 'example.de', registrar: 'inwx' },
    result: { ok: true, ns: ['ns1.valitype.com', 'ns2.valitype.com'] },
  },
  {
    id: 'job_42b',
    type: 'hosting.provision',
    status: 'running',
    subscription_id: 18,
    current_step: 2, total_steps: 5,
    created_at: new Date(NOW - 12 * 60_000).toISOString(),
    finished_at: null,
    payload: { account: 'cust-204', plan: 17 },
  },
  {
    id: 'job_42c',
    type: 'domain.provision',
    status: 'failed',
    subscription_id: 19,
    current_step: 1, total_steps: 3,
    created_at: new Date(NOW - 30 * 60_000).toISOString(),
    finished_at: new Date(NOW - 28 * 60_000).toISOString(),
    payload: { domain: 'kaputt.de', registrar: 'inwx' },
    result: { error: 'registrar_unreachable' },
  },
  {
    id: 'job_42d',
    type: 'vps.provision',
    status: 'pending',
    subscription_id: 20,
    current_step: 0, total_steps: 4,
    created_at: new Date(NOW - 5 * 60_000).toISOString(),
    finished_at: null,
    payload: { node: 'pve01', cpus: 4, ram_gb: 16 },
  },
];

export function nexusJobsFixture({ status, type, subscriptionId } = {}) {
  let list = JOBS;
  if (status) list = list.filter((j) => j.status === status);
  if (type) list = list.filter((j) => j.type === type);
  if (subscriptionId) list = list.filter((j) => String(j.subscription_id) === String(subscriptionId));
  return { jobs: list };
}

export function nexusJobDetailFixture(id) {
  return JOBS.find((j) => j.id === id) ?? null;
}
